<div class="container_dialog">
    <div class="header_popup">
        <div class="title_popup">
            <span>{{"quotations_and_orders.confirm_status_update" | translate}}</span>
        </div>
        <button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <form novalidate="" class="display_form ng-untouched ng-pristine ng-invalid">
        <div class="display_block">
            <div class="img_block">
                <div class="drop_zone">
                    <span class="inside_block"></span>
                    <span class="text_zone">
                        {{"quotations_and_orders.confirm_change" | translate}}  ?</span>
                </div>
                <div class="image_preview_container"></div>
            </div>
        </div>
    </form>
    <div class="submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
            <span>{{"common.cancel" | translate}}</span>
        </button>
        <button class="save_btn_pop_up blue_btn" (click)="save()">
            <span> {{"common.confirm" | translate}} </span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
    </div>
</div>
